import React, { useState } from "react";
import styles from "./SearchSection.module.scss";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { propertyType } from "../../utils/constants";

export const SearchSection = ({
  searchFn,
}: {
  searchFn: (
    propertyType: string,
    location: string,
    businessType: string
  ) => void;
}) => {
  const [type, setType] = useState("");
  const [location, setLocation] = useState("");
  const [searcherItemsSelected, setSearcherItemsSelected] = useState([
    {
      id: 0,
      text: "Venta",
      selected: true,
    },
    {
      id: 1,
      text: "Renta",
      selected: false,
    },
    {
      id: 2,
      text: "Renta Vacacional",
      selected: false,
    },
  ]);

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  const handleLocationChange = (event: SelectChangeEvent) => {
    setLocation(event.target.value as string);
  };

  const handleSearcherItemSelection = (id: number) => {
    const searcherItemsSelectedCopy = [...searcherItemsSelected];
    searcherItemsSelectedCopy.forEach((item) => {
      item.selected = false;
    });
    searcherItemsSelectedCopy[id].selected = true;
    setSearcherItemsSelected(searcherItemsSelectedCopy);
  };

  const handleSearch = () => {
    const businessType = searcherItemsSelected.find(
      (item) => item.selected
    )?.text;
    if (businessType) {
      searchFn(type, location, businessType);
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        Compra o renta facilmente cualquier propiedad
      </h1>
      <h2 className={styles.subTitle}>
        Conoce las mejores propiedades en las mejores zonas de la ciudad
      </h2>

      <div className={styles.searcherSection}>
        <div className={styles.searcherOptionContainer}>
          {searcherItemsSelected.map((item) => {
            return (
              <button
                key={item.id}
                className={`${styles.searcherOptionBtn} ${
                  item.selected ? styles.selected : ""
                }`}
                onClick={() => handleSearcherItemSelection(item.id)}
              >
                {item.text}
              </button>
            );
          })}
        </div>

        <div className={styles.selectionsSection}>
          <div className={styles.type}>
            <FormControl sx={sx}>
              <InputLabel sx={{ color: "#EFC282" }} id="type-label">
                Tipo de propiedad
              </InputLabel>
              <Select
                sx={selectSx}
                labelId="type-label"
                id="type-select"
                value={type}
                label="Age"
                onChange={handleTypeChange}
              >
                <MenuItem value={propertyType.House}>Casa</MenuItem>
                <MenuItem value={propertyType.Apartment}>Departamento</MenuItem>
                <MenuItem value={propertyType.Lot}>Terreno</MenuItem>
                <MenuItem value={propertyType.Studio}>Estudio</MenuItem>
                <MenuItem value={propertyType.Local}>Local</MenuItem>
                <MenuItem value={propertyType.Warehouse}>Bodega</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className={styles.location}>
            <FormControl sx={sx}>
              <InputLabel sx={{ color: "#EFC282" }} id="type-label">
                Ubicación
              </InputLabel>
              <Select
                sx={selectSx}
                labelId="type-label"
                id="type-select"
                value={location}
                label="Age"
                onChange={handleLocationChange}
              >
                <MenuItem value={"Cancún"}>Cancún</MenuItem>
                <MenuItem value={"Playa del carmen"}>Playa del carmen</MenuItem>
                <MenuItem value={"Tulúm"}>Tulúm</MenuItem>
                <MenuItem value={"Mérida"}>Mérida</MenuItem>
                <MenuItem value={"Puerto Morelos"}>Puerto Morelos</MenuItem>
                <MenuItem value={"Pachuca"}>Pachuca</MenuItem>
                <MenuItem value={"Estado de México"}>Estado de México</MenuItem>
                <MenuItem value={"Bahía de Banderas"}>Bahía de Banderas</MenuItem>
                <MenuItem value={"Ciudad Sahagún"}>Ciudad Sahagún</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className={styles.search}>
            {/*TODO: Center this button */}
            <button className={styles.searchBtn} onClick={handleSearch}>
              Buscar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const sx = {
  width: "80%",

  "@media (max-width: 768px)": {
    width: "100%",
  },
};

const selectSx = {
  border: "solid 1px #EFC282",
  color: "#EFC282",
  backgroundColor: "black",
};
